import { formatInTimeZone } from 'date-fns-tz';
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const PROFILE_PROPS_MAP = new Map([['id', 'account_id'], ['fullName', 'name'], ['nickname', 'nickname'], ['timezone', 'zoneinfo'], ['locale', 'locale'], ['avatarUrl', 'picture'], ['email', 'email']]);

// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const EXTENDED_PROFILE_PROPS_MAP = new Map([['title', 'job_title'], ['department', 'department'], ['companyName', 'organization'], ['location', 'location'], ['phoneNumber', 'phone_number']]);
export const fromManageAPIResponse = res => {
  const data = res.account;
  const extendedData = data && data.extended_profile || {};
  if (!data) {
    return null;
  }
  const timeZone = data.zoneinfo;
  const localTime = ({
    format
  }) => {
    if (!timeZone) {
      return null;
    }
    try {
      return formatInTimeZone(new Date(), timeZone, format);
    } catch (error) {
      // TODO: PTC-4908 send error to sentry for reporting
      return null;
    }
  };
  const profileProps = Array.from(PROFILE_PROPS_MAP.keys()).reduce((acc, key) => {
    if (PROFILE_PROPS_MAP.has(key)) {
      acc[key] = data[PROFILE_PROPS_MAP.get(key)];
    }
    return acc;
  }, {});
  const extendedProfileProps = Array.from(EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key) => {
    if (EXTENDED_PROFILE_PROPS_MAP.has(key)) {
      acc[key] = extendedData[EXTENDED_PROFILE_PROPS_MAP.get(key)];
    }
    return acc;
  }, {});
  return {
    ...profileProps,
    ...extendedProfileProps,
    localTime
  };
};
export const toManageAPIInput = input => {
  const output = {
    extended_profile: {}
  };
  Object.keys(input).forEach(key => {
    if (PROFILE_PROPS_MAP.has(key)) {
      output[PROFILE_PROPS_MAP.get(key)] = input[key];
    }
    if (EXTENDED_PROFILE_PROPS_MAP.has(key)) {
      output.extended_profile[EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    }
  });
  return output;
};